import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { useSnapshot } from "valtio";
import { StyledBreadcrumb, Tabs } from "@aureskonnect/react-ui";
import {
    setNumberClick,
    store,
} from "../../../components/VerticalLayout/store";
import { setDefaultSetting } from "@components/Common/DefaultSettingModal/ShopDefaultSetting/store";
import PageTitle from "@components/Common/PageTitle";
import MessageInfo from "@components/Common/MessageInfo";
import CustomerAccounts from "./CustomerAccounts";
import CustomerAccountShop from "./CustomerAccountShop";
import { MainColorTabsWrapper } from "@components/Common/MainColorTabsWrapper";
import { NProgressWrapper } from "@components/NProgressWrapper";
import { DefaultModalWrapper } from "@components/Common/DefaultSettingModal/DefaultModalWrapper";
import { DefaultModalContentWrapper } from "@components/Common/DefaultSettingModal/DefaultModalContentWrapper";
import { DefaultSettingModal } from "@components/Common/DefaultSettingModal/ShopDefaultSetting";
import ModalLoading from "@components/Common/ModalLoading";
import { useSelector } from "react-redux";
import { useFetchGlobal } from "../../../api/hooks";
import { createDefaultSettings } from "./hooks";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
export default function CustomerAccount() {
    const { fetchGlobal } = useFetchGlobal();

    const [isModalLoadingOpened, setIsModalLoadingOpened] = React.useState(
        false
    );
    const [modalLoadingData, setModalLoadingData] = React.useState({
        title: "",
        message: "",
    });
    const { t } = useTranslation();
    const selectedAccount = useSelector(
        (state: any) => state.global.selectedAccount
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { oneShop, franchiseID, numberClick, shopID } = useSnapshot(store);
    const [isDefaultSetting, setIsDefaultSetting] = React.useState<boolean>(
        false
    );
    const [isCreated, setIsCreated] = React.useState<boolean>(false);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [limit, setLimit] = React.useState<number>(1);
    const tabs1 = <CustomerAccountShop />;
    const tabs2 = (
        <Tabs
            tabs={[
                {
                    content: <CustomerAccountShop />,
                    disabled: false,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark cmn_btn_boutique"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Customer Account")}
                        </div>
                    ),
                },
                {
                    content: <CustomerAccounts />,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark border-0 cmn_btn_franchise"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Shops Customer Account")}
                        </div>
                    ),
                },
            ]}
        />
    );
    const breadcrumbItems = useMemo(
        () => [
            {
                item: "SETTINGS",
                link: `${process.env.REACT_APP_PORTAIL_URL}`,
            },
            {
                item: selectedAccount?.toUpperCase() || "",
                link: oneShop ? "/setting/customer-account" : "/compte",
            },
            {
                item: t("General settings").toUpperCase(),
                link: "#",
            },
            {
                item: t("Customer account informations").toUpperCase(),
                link: "#",
            },
        ],
        [selectedAccount, oneShop, t]
    );
    const fetchSettings = async () => {
        try {
            let result: any = await fetchGlobal(
                `${
                    process.env.REACT_APP_API_V2_URL
                }/settings/list/setting?franchiseId=${franchiseID}&shopId=${
                    oneShop ? shopID : 0
                }`,
                {
                    method: "GET",
                    headers: { "Accept-Language": i18nextLng },
                }
            );
            if (!result) {
                throw new Error("No result from fetchGlobal");
            }
            setIsDefaultSetting(result.settingEmpty);
            setIsOpen(result.emptyShop);
            setDefaultSetting(result.defaultSetting);

            if (result.settingEmpty && numberClick === 0) {
                let data: any = await createDefaultSettings(
                    franchiseID,
                    fetchGlobal
                );
                if (data.error) {
                    throw Error("error");
                } else {
                    setIsCreated(true);
                }
            }
        } catch (error) {
            console.error("Error in fetchSettings:", error);
        }
    };
    const shouldShowDefaultModal =
        isDefaultSetting && numberClick === 0 && isCreated;
    const shouldShowEmptyShopModal = isOpen && numberClick === 0;

    React.useEffect(() => {
        const controller = new AbortController();
        fetchSettings();
        return () => {
            controller.abort();
        };
        // eslint-disable-next-line
    }, []);

    return (
        <React.Fragment>
            <ToastContainer limit={limit} />
            <PageTitle title={t("General settings")} />
            <div className="page-content__clz">
                <StyledBreadcrumb items={breadcrumbItems} />
                <MessageInfo
                    message={t(
                        "The legal information related to an account can be accessed in this section."
                    )}
                />
                <MainColorTabsWrapper>
                    {oneShop ? tabs1 : tabs2}
                </MainColorTabsWrapper>
            </div>
            {shouldShowDefaultModal && (
                <DefaultModalWrapper
                    isConfigurationModalOpened={isDefaultSetting}
                    setIsConfigurationModalOpened={setIsDefaultSetting}
                    setIsLoading={setIsLoading}
                    numberClick={numberClick}
                    setNumberClick={setNumberClick}
                    setLimit={setLimit}
                    setIsModalLoadingOpened={setIsModalLoadingOpened}
                    setModalLoadingData={setModalLoadingData}
                >
                    <DefaultModalContentWrapper />
                </DefaultModalWrapper>
            )}
            {shouldShowEmptyShopModal && (
                <DefaultSettingModal
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                    setIsLoading={setIsLoading}
                    setNumberClick={setNumberClick}
                />
            )}
            {isModalLoadingOpened && (
                <ModalLoading
                    isOpen={isModalLoadingOpened}
                    data={modalLoadingData}
                />
            )}
            <NProgressWrapper isLoading={isLoading} />
        </React.Fragment>
    );
}
